// ActionProvider.js
export class ActionProvider {
  constructor(createChatBotMessage, setStateFunc, createClientMessage, triggerTransactionLookup) {
    this.createChatBotMessage = createChatBotMessage;
    this.setState = setStateFunc;
    this.createClientMessage = createClientMessage;
    this.triggerTransactionLookup = triggerTransactionLookup;
  }

  handleRecognizedIdLookup = async (message) => {
    if (!message) return;

    try {
      const response = await this.triggerTransactionLookup({ message });
      const data = response.data;

      if (!data?.length) {
        this.handleUnknown(`${message}.`);
        return;
      }

      const item = data[0];
      const tagNumber = item["Tag Number"] || "N/A"; // Access with bracket notation for spaces
      const receiptType = item["Receipt Type"] || "N/A";
      const assignedAP = item["Assigned AP"] || "N/A";
      const assignedTreasurer = item["Assigned Treasurer"] || "N/A";
      const assignedApprover = item["Assigned Approver"] || "None";
      const findings = item["Findings"] || "N/A";
      const voucherNo = item["Voucher No"] || "N/A";

      // Fix 1: Remove the redundant header from the reply string
      // Fix 2: Add a header to a separate variable
      const header = `Here are the details for transaction "${message}":`;
      const reply =
        `Tag Number: ${tagNumber}\n` +
        `Receipt Type: ${receiptType}\n` +
        `Assigned AP: ${assignedAP}\n` +
        `Assigned Treasurer: ${assignedTreasurer}\n` +
        `Assigned Approver: ${assignedApprover}\n` +
        `Findings: ${findings}\n` +
        `Voucher No.: ${voucherNo}`;

      // Fix 3: Combine the header and reply correctly
      const responseMessage = this.createChatBotMessage(`${header}\n\n\n${reply}  `);

      this.setChatbotMessage(responseMessage);
    } catch (err) {
      console.error("Transaction lookup failed:", err);
      const errorMessage = this.createChatBotMessage(
        `There was an error fetching the transaction ${message}.`
      );
      this.setChatbotMessage(errorMessage);
    }
  };

  handleUnknown = (message) => {
    const responseMessage = this.createChatBotMessage(
      `I'm not sure what "${message}" means. Try entering a transaction like:TAG NUMBER 10739 RECEIPT UNOFFICIAL`
    );
    this.setChatbotMessage(responseMessage);
  };

  setChatbotMessage = (message) => {
    this.setState((prev) => ({
      ...prev,
      messages: [...prev.messages, message],
    }));
  };
}
